import FeedbackModel from 'src/models/Feedback';
import { Reducer, Action } from 'redux';
import { call, select, all, takeEvery, fork } from 'redux-saga/effects';
import { actionCreators as layoutActionCreators } from 'src/reducers/Layout';
import { selectors as authSelectors } from 'src/reducers/Auth';
import Api from '../api';
import { delay } from 'bluebird';

export interface IFeedbackState {
    feedbacks: Array<FeedbackModel>;
}

const initialState: IFeedbackState = {
    feedbacks: undefined,
};

export enum actionTypes {
    CREATE_FEEDBACK = '[feedback] CREATE_FEEDBACK',
    GET_FEEDBACKS = '[feedback] GET_FEEDBACKS',
    GET_FEEDBACKS_SUCCESS = '[feedback] GET_FEEDBACKS_SUCCESS',
}

export const actionCreators = {
    createFeedback: (feedback: FeedbackModel) => {
        return { type: actionTypes.CREATE_FEEDBACK, payload: { feedback } };
    },
    getFeedbacks: () => {
        return { type: actionTypes.GET_FEEDBACKS };
    },
    getFeedbacksSuccess: (feedbacks: Array<FeedbackModel>) => {
        return { type: actionTypes.GET_FEEDBACKS_SUCCESS, payload: feedbacks };
    },
};

const reducer: Reducer<IFeedbackState> = (state: IFeedbackState = initialState, action: Action): IFeedbackState => {
    switch (action.type) {
        case actionTypes.GET_FEEDBACKS_SUCCESS: {
            const payload = (action as { type: string; payload: Array<FeedbackModel> }).payload;
            return {
                ...state,
                feedbacks: payload,
            };
        }
        default:
            return state;
    }
};

export default reducer;

const sagas = {
    createFeedback: function* (action: { type: string; payload: { feedback: FeedbackModel } }): unknown {
        yield call(layoutActionCreators.waitIniitalLoadState);
        const jwt = yield select(authSelectors.jwt);

        yield all([call(Api.Feedback.createFeedback, action.payload.feedback, jwt), delay(200)]);
    },
};

const watches = {
    createFeedback: function* () {
        yield takeEvery(actionTypes.CREATE_FEEDBACK, sagas.createFeedback);
    },
};

export function* saga() {
    yield fork(watches.createFeedback);
}



// WEBPACK FOOTER //
// ./src/reducers/Feedback.ts